import { z } from "zod";

import { PaymentDepositAccountInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { ZodError } from "zod";

// 全角カタカナ、左右括弧、ハイフン、「.」、半角・全角スペースを許可している。
// eslint-disable-next-line no-useless-escape, no-irregular-whitespace
const BANK_ACCOUNT_HOLDER_NAME_REGEX = /^([ァ-ヶ]|\）|\（|ー|\.|\ |\　)*$/;

/**
 *
 * @description クレジットカード情報の設定用のバリデーションスキーマ
 *
 * PaymentCreditInputSchema は、hotelID, paymentToken を受け取る。
 * paymentToken は Payjp の element で生成されたトークンを受け取る。
 */
export const PaymentDepositAccountInputZodSchema = PaymentDepositAccountInputSchema.extend({
	minimumTransferAmount: z
		.number()
		.min(1_000, "1,000円以上の金額を設定してください")
		.max(1_000_000, "1,000,000円以下の金額を設定してください"),
	bankCode: z
		.string()
		.min(4, "金融機関コードは4桁で入力してください")
		.max(4, "金融機関コードは4桁で入力してください"),
	bankBranchCode: z.string().min(3, "支店コードは3桁で入力してください").max(3, "支店コードは3桁で入力してください"),
	bankAccountType: z.string().min(1, "口座種類は必須項目です"),
	bankAccountNumber: z
		.string()
		.min(7, "口座番号は7桁で入力してください")
		.max(7, "口座番号は7桁で入力してください")
		.regex(/^\d+$/, "口座番号は整数で入力してください"),
	bankAccountHolderName: z
		.string()
		.min(1, "口座名義（カナ）は必須項目です")
		.max(50, "口座名義（カナ）は100文字以内で入力してください")
		.regex(
			BANK_ACCOUNT_HOLDER_NAME_REGEX,
			"口座名義（カナ）は全角カタカナ・左右括弧・ハイフン・コンマで入力してください",
		),
});

export type PaymentDepositAccountInputZodSchemaType = z.infer<typeof PaymentDepositAccountInputZodSchema>;

export type PaymentDepositAccountInputZodParseError = ZodError<PaymentDepositAccountInputZodSchemaType>;
